import { ReactElement, ReactNode } from 'react';
import { AccountSettingsContext } from './context';
import { GetMeResponseData } from '@/api';

type Props = {
    readonly data: GetMeResponseData;
    readonly children?: ReactNode;
};
export function AccountSettingsProvider(props: Props): ReactElement {
    const { data, children } = props;

    return (
        <AccountSettingsContext.Provider
            value={{
                data
            }}
        >
            {children}
        </AccountSettingsContext.Provider>
    );
}
